export function clientCarousel() {

	let carousel    = $('.js-client-carousel');
	let windowWidth = $(window).width();

	if(windowWidth < 991) {
		carousel.addClass('owl-carousel');
		carousel.addClass('owl-theme');

		carousel.owlCarousel({
			nav: false,
			dots: false,
			loop: true,
			autoplay: true,
			responsive: {
				0 : {
					items: 1
				},
				600: {
					items: 2
				},
				768: {
					items: 4
				}
			}
		});
	} else {
		carousel.trigger('destroy.owl.carousel');
		carousel.removeClass('owl-carousel');
		carousel.removeClass('owl-theme');
	}

	return 'clientCarousel';
}

